import React from "react";
import { Box, Typography } from "@mui/material";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("Delivery dashboard render error:", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f6fa",
            p: 3,
          }}
        >
          <Typography sx={{ color: "#b00020", textAlign: "center" }}>
            {this.state.error.message || "Something went wrong loading the dashboard."}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}
